import {Component, EventEmitter, Input, Output} from '@angular/core';
import {animate, state, style, transition, trigger} from "@angular/animations";
import {YamlMenuFunzionalita} from "@model";
import { SIDE_MENU_CATEGORIES } from "@constants";

@Component({
  selector: 'side-menu-item',
  templateUrl: './side-menu-item.component.html',
  styleUrls: ['./side-menu-item.component.scss'],
  animations : [
    trigger('slideInOut', [
      state('in', style({ height: '*', opacity: 1, transform: 'translateY(2)' })),
      state('out', style({ height: '0px', opacity: 0, transform: 'translateY(-10)', overflow: 'hidden' })),
      transition('in => out', animate('300ms ease-in-out')),
      transition('out => in', animate('300ms ease-in-out'))
    ])
  ]
})
export class SideMenuItemComponent {
  @Input() selectedIndex: number = -1;
  @Input() sideMenuIndex: number = -1;
  @Input() selectedSideMenuIndex: number = -1;
  @Input() sideMenuConfigs?: YamlMenuFunzionalita[];
  @Output() onSelection : EventEmitter<number> = new EventEmitter<number>();
  @Output() onNavigate : EventEmitter<YamlMenuFunzionalita> = new EventEmitter<YamlMenuFunzionalita>();

  get header(){
    return SIDE_MENU_CATEGORIES.get(this.sideMenuIndex);
  }

  get isOpen() {
    return this.selectedSideMenuIndex === this.sideMenuIndex
  }

  isActive (menuConfig: YamlMenuFunzionalita): boolean {
    return menuConfig.id === this.selectedIndex;
  }

  handleSelection() {
    const raisingIndex = this.isOpen ? -1 : this.sideMenuIndex;
    this.onSelection.emit(raisingIndex);
  }

  loadContent(value: YamlMenuFunzionalita) {
    this.onNavigate.emit(value);
  }

}
